// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"0aa7c007","25":"45fe69c9","115":"59f72cce","118":"f87cbef9","180":"1041d1b0","295":"67ad389e","331":"0db6110f","447":"aed1da6c","536":"96c2f0e2","723":"ffc857a5","739":"159e98d3","751":"938e8fc1","777":"e3adb4e9","925":"8bb03eb1"}[chunkId] + ".chunk.js";
};